import { useHistoryDrilldown } from '@src/packages/dashboard/components/ReportSummary/hooks/useHistoryDrilldown';
import type {
  ExecutionsHistoryScheduleQuery,
  ScheduleDrilldownSectionData,
  ScheduleDrilldownTarget,
} from '@src/models/interfaces/executionsHistoryDashboard.interface';
import ExecutionsHistoryDashboardService from '@src/services/ExecutionsHistoryDashboardService';

const loadScheduleDrilldown = (
  service: ExecutionsHistoryDashboardService,
  request: Parameters<ExecutionsHistoryDashboardService['getScheduleDrilldown']>[0],
) => service.getScheduleDrilldown(request);

export const useScheduleHistoryDrilldown = (
  query: ExecutionsHistoryScheduleQuery | undefined,
  target: ScheduleDrilldownTarget | null,
  search: string,
  page: number,
) =>
  useHistoryDrilldown<ExecutionsHistoryScheduleQuery, ScheduleDrilldownTarget, ScheduleDrilldownSectionData>(
    query,
    target,
    search,
    page,
    { loadDrilldown: loadScheduleDrilldown },
  );
